<template>
  <div class="l-tag" :class="[`l-tag-${type}`, isCard ? 'l-tag-card' : '']" :style="{'--tag-bg-color-': colorRgb(info.colorInfo, .3), '--tag-text-color': info.colorInfo}">
    {{ info.returnValue }}
  </div>
</template>

<script>
import { colorRgb } from '@/components/schoolInstrument/mixins/utils'
export default {
  // 组件名称
  name: 'lTag',
  // 组件参数 接收来自父组件的数据
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: '1'
    },
    isCard: {
      type: Boolean,
      default: false
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
      return {}
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    colorRgb(str, opc) {
      if (!str) return
      return colorRgb(str, opc)
    }
  },
}
</script>

<style scoped lang="scss">
.l-tag {
  font-weight: 400;
  font-size: 10px;
  padding: 4px 6px;
  border-radius: 10px;
  box-sizing: border-box;
  margin-right: 5px;
}

.l-tag-1 {
  background-color: var(--tag-bg-color-);
  color: var(--tag-text-color);
}

.l-tag-card.l-tag{
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.l-tag-2 {
  color: var(--tag-text-color);
}
</style>
